module.exports = __webpack_public_path__ + "img/28.56e06175.jpg";